import { render, staticRenderFns } from "./CerrarSesion.vue?vue&type=template&id=33496a74&scoped=true"
import script from "./CerrarSesion.vue?vue&type=script&setup=true&lang=js"
export * from "./CerrarSesion.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CerrarSesion.vue?vue&type=style&index=0&id=33496a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33496a74",
  null
  
)

export default component.exports